import {
    collection,
    getVariantByParentType,
    globalCounterPath,
    parentTypeFor,
    readGlobalCount,
    refs,
} from "../_variants/index.js";
import {
    makeAttached,
    makeDropdown,
    pad
} from "../../../utils.js";

const refsToUpdate = ["Number", "ID", "Comment", "Signedoff", "Date", "Parent", "ParentID", "Reason", "Cancelled"];

export const addDQN = ({ form, pageItem, store, attachedItems, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const dqnCollection = collection(variant, "DQNs");
    const dqnCollectionTail = parentTypeFor(variant, "DQNs");
    const dqnRefs = refs(variant, "DQNs");
    const docCollection = collection(variant, "Documents");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollection = collection(variant, "Drawings");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollection = "Database/Effectivities";
    const effectivityCollectionTail = "Effectivities";
    const dqnParentType = parentTypeFor(variant, "DQNs");
    const counterPath = globalCounterPath(variant, "counts/database/dqn/count");

    form.setConfig({
        "title": "Add DQN",
        "type": "push",
        "location": dqnCollection,
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${variant.docPrefix}DQN-${pad(readGlobalCount(store, variant, ["database", "dqn"]))}`
            }
        }, {
            "label": "Comment",
            "name": "Comment",
            "type": "text",
            "divClass": "col-span-2"
        }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "showSelectAll": true,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": "Effectivities",
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems.Effectivities.items, "Number", "ID")
        }, {
            "label": "Reason",
            "name": "Reason",
            "type": "dropdown",
            "required": true,
            "dataLocation": "Database/DQNReasons",
            "labelKey": "Name",
            "idKey": "Name"
        }],
        async preSubmitHook({ data, db }) {
            const number = await db.utils.allocateCount(counterPath);
            return {
                "Date": {
                    "Created": new Date().toISOString(),
                    "Cancelled": "N/A",
                    "Signedoff": "N/A"
                },
                "Cancelled": false,
                "Signedoff": false,
                "Aircraft": pageItem.Aircraft,
                "Author": store.getters.userName,
                "Parent": pageItem.Number,
                "ParentID": pageItem.ID,
                "ParentType": meta.ParentType,
                "Number": `${variant.docPrefix}DQN-${pad(number)}`,
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail]),
                [meta.ParentType]: {
                    [pageItem.ID]: true
                }
            }
        },
        postSubmitHook({ db, data, typeRef }) {
            data.ID = typeRef.key;
            db.set(`Database/${meta.ParentType}/${pageItem.ID}/${dqnCollectionTail}/${data.ID}`, true);
            db.utils.addAllTo(data, docCollection, docCollectionTail, dqnParentType);
            db.utils.addAllTo(data, drawingCollection, drawingCollectionTail, dqnParentType);
            db.utils.addAllTo(data, effectivityCollection, effectivityCollectionTail, dqnParentType);
            db.utils.updateRefs(data, dqnRefs, refsToUpdate);
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const editDQN = async ({ form, item, attachedItems, store, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const dqnCollection = collection(variant, "DQNs");
    const dqnRefs = refs(variant, "DQNs");
    const docCollection = collection(variant, "Documents");
    const docCollectionTail = parentTypeFor(variant, "Documents");
    const drawingCollection = collection(variant, "Drawings");
    const drawingCollectionTail = parentTypeFor(variant, "Drawings");
    const effectivityCollection = "Database/Effectivities";
    const effectivityCollectionTail = "Effectivities";
    const dqnParentType = parentTypeFor(variant, "DQNs");

    form.setValues({
        "Comment": item.Comment,
        [docCollectionTail]: Object.keys(item[docCollectionTail] || {}),
        [drawingCollectionTail]: Object.keys(item[drawingCollectionTail] || {}),
        [effectivityCollectionTail]: Object.keys(item[effectivityCollectionTail] || {}),
        "Reason": item.Reason
    });
    form.setConfig({
        "title": "Update DQN",
        "type": "update",
        "location": `${dqnCollection}/${item.ID}`,
        "set": true,
        "fields": [{
            "label": "Comment",
            "name": "Comment",
            "type": "text",
            "divClass": "col-span-3"
        }, {
            "label": "Select Documents",
            "name": docCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "showSelectAll": true,
            "dropdownData": makeDropdown(store, attachedItems[docCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Drawings",
            "name": drawingCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[drawingCollectionTail].items, "Number", "ID")
        }, {
            "label": "Select Effectivities",
            "name": effectivityCollectionTail,
            "type": "dropdown",
            "multiple": true,
            "required": false,
            "dropdownData": makeDropdown(store, attachedItems[effectivityCollectionTail].items, "Number", "ID")
            }, {
                "label": "Reason",
                "name": "Reason",
                "type": "dropdown",
                "required": true,
                "dataLocation": "Database/DQNReasons",
                "labelKey": "Name",
                "idKey": "Name"
            }],
        preSubmitHook({ data }) {
            return {
                [docCollectionTail]: makeAttached(data[docCollectionTail]),
                [drawingCollectionTail]: makeAttached(data[drawingCollectionTail]),
                [effectivityCollectionTail]: makeAttached(data[effectivityCollectionTail])
            }
        },
        postSubmitHook({ db, data, typeRef }) {
            db.utils.addAllTo(data, docCollection, docCollectionTail, dqnParentType);
            db.utils.addAllTo(data, drawingCollection, drawingCollectionTail, dqnParentType);
            db.utils.addAllTo(data, effectivityCollection, effectivityCollectionTail, dqnParentType);
            db.utils.updateRefs(data, dqnRefs, refsToUpdate);
        }
    });
    await form.getDropdownData();

    form.toggle();
};

export const cancelDQN = ({ form, item, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const dqnCollection = collection(variant, "DQNs");
    const dqnRefs = refs(variant, "DQNs");

    form.setConfig({
        "title": "Cancel DQN",
        "description": `Are you sure you want to cancel DQN ${item.Number}?`,
        "type": "update",
        "location": `${dqnCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                "Cancelled": true,
                "Date/Cancelled": new Date().toISOString()
            }
        },
        async postSubmitHook({ db, data }) {
            await db.utils.updateRefs({ ...item, ...data, "ID": item.ID }, dqnRefs, refsToUpdate);
        }
    });
    form.toggle();
};

export const signoffDQN = ({ form, item, meta, pageItem }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? item?.ParentType ?? pageItem?.ParentType);
    const dqnCollection = collection(variant, "DQNs");
    const dqnRefs = refs(variant, "DQNs");

    form.setConfig({
        "title": "Signoff DQN",
        "description": `Are you sure you want to signoff DQN ${item.Number}?`,
        "type": "update",
        "location": `${dqnCollection}/${item.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                "Signedoff": true,
                "Date/Signedoff": new Date().toISOString()
            }
        },
        postSubmitHook({ db, newData }) {
            db.utils.updateRefs(newData, dqnRefs, refsToUpdate);
        }
    });
    form.toggle();
};

export const linkDQN = ({ form, pageItem, meta }) => {
    const variant = getVariantByParentType(meta?.ParentType ?? pageItem?.ParentType);
    const dqnCollection = collection(variant, "DQNs");
    const dqnCollectionTail = parentTypeFor(variant, "DQNs");
    const dqnRefs = refs(variant, "DQNs");

    form.setConfig({
        "title": "Link DQN",
        "type": "update",
        "location": `Database/${meta.ParentType}/${pageItem.ID}`,
        "fields": [{
            "label": "DQN",
            "name": "DQN",
            "type": "dropdown",
            "labelKey": "Number",
            "idKey": "ID",
            "dataLocation": dqnRefs,
            "search": true
        }],
        preSubmitHook({ liveInputData }) {
            return {
                "DQN": null,
                [`${dqnCollectionTail}/${liveInputData.DQN}`]: true
            }
        },
        postSubmitHook({ db, liveInputData }) {
            db.update(`${dqnCollection}/${liveInputData.DQN}/${meta.ParentType}/${pageItem.ID}`, true);
        }
    });
    form.getDropdownData();

    form.toggle();
};

export const unlinkDQN = ({ form, rowItem, pageItem, toast, meta }) => {
    if (rowItem.ParentID === pageItem.ID) {
        toast.error("You cannot unlink this DQN from this item.");
        return;
    }
    const variant = getVariantByParentType(meta?.ParentType ?? rowItem?.ParentType ?? pageItem?.ParentType);
    const dqnCollectionTail = parentTypeFor(variant, "DQNs");
    form.setConfig({
        "title": "Unlink DQN",
        "location": `Database/${meta.ParentType}/${pageItem.ID}/${dqnCollectionTail}/${rowItem.ID}`,
        "type": "delete",
        "fields": []
    });
    form.toggle();
};
